import { createFileRoute, Link } from "@tanstack/react-router";
import { ShieldCheck, ClipboardCheck, ScrollText, MapPin, Building2, Mail } from "lucide-react";
import { PageHeader } from "@/components/page-header";

// US-061 — Settings landing. The Functional currency is the single place a
// currency identifier appears in the UI (single-currency deployment); all
// monetary amounts elsewhere are shown without a symbol.

// Single functional currency for this deployment. No multi-currency data
// model (v1 non-goal) — this is a fixed display value.
const FUNCTIONAL_CURRENCY = "PKR";

const LINKS = [
  { to: "/settings/roles", label: "Roles", icon: ShieldCheck },
  { to: "/settings/locations", label: "Locations", icon: MapPin },
  { to: "/settings/departments", label: "Departments", icon: Building2 },
  { to: "/settings/approvals", label: "Approval Chains", icon: ClipboardCheck },
  { to: "/settings/match-policy", label: "Match Policy", icon: ClipboardCheck },
  { to: "/settings/email", label: "Email", icon: Mail },
  { to: "/audit-logs", label: "Audit Logs", icon: ScrollText },
] as const;

export const Route = createFileRoute("/settings/")({
  head: () => ({
    meta: [{ title: "Settings — ProcureFlow" }],
  }),
  component: SettingsIndexPage,
});

function SettingsIndexPage() {
  return (
    <div className="space-y-6" data-testid="settings-section">
      <PageHeader title="Settings" description="Workspace configuration." />

      <div className="rounded-2xl bg-card border border-border shadow-elegant p-6 max-w-md">
        <label className="text-xs font-medium text-muted-foreground">Functional currency</label>
        <p className="mt-1 text-lg font-semibold tracking-tight" data-testid="functional-currency">
          {FUNCTIONAL_CURRENCY}
        </p>
        <p className="mt-1 text-xs text-muted-foreground">
          All amounts are shown without a currency symbol. This single-currency deployment uses{" "}
          {FUNCTIONAL_CURRENCY}.
        </p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {LINKS.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="rounded-xl border border-border bg-card p-4 shadow-elegant hover:bg-accent transition inline-flex items-center gap-2.5"
          >
            <Icon className="h-4 w-4 text-muted-foreground" />
            <span className="text-sm font-medium">{label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
